// extracted by mini-css-extract-plugin
export default {"view":"animatedview_view__wTbhQ","fadeIn":"animatedview_fadeIn__GPYeQ","minHeight":"animatedview_minHeight__8wTAc"};